import React from 'react';

function SearchIcon() {
  return (
    <svg className="search-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <title>Search</title>
      <path d="M39.567 11.2c3.783 3.783 5.866 8.817 5.866 14.167S43.35 35.75 39.567 39.533C35.783 43.317 30.75 45.4 25.4 45.4s-10.383-2.083-14.167-5.867C7.45 35.75 5.367 30.717 5.367 25.367S7.45 14.983 11.233 11.2C15.017 7.417 20.05 5.333 25.4 5.333S35.783 7.417 39.567 11.2zM46.75 39c2.5-3.933 3.967-8.6 3.967-13.617C50.717 11.367 39.367 0 25.367 0 11.35 0 0 11.367 0 25.383 0 39.4 11.35 50.767 25.35 50.767c5.083 0 9.817-1.5 13.783-4.067l1.15-.8 18.1 18.1L64 58.283l-18.083-18.1L46.75 39z" fillRule="evenodd"/>
    </svg>
  );
}

export default SearchIcon


// WEBPACK FOOTER //
// ./modules/Common/components/svg/SearchIcon.js